import { axiosInstance } from "@/lib/api/client";

export const getCurrentUser = async () =>
  axiosInstance.get("/current-user/me").then((response) => response.data);
